(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muheyya-weekly-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muheyya-weekly')) {
    customElements.define('muheyya-weekly', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.half = 0;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 989px)');
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.syncPage();
        this.mobile.addEventListener('change', () => { if (!this.busy) { this.half = 0; this.syncPage(); } }, options);
        this.addEventListener('click', event => {
          const link = event.target.closest('a[data-direction]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.changePage(link.dataset.direction);
        }, options);
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.closest('input,select,textarea')) return;
          event.preventDefault();
          this.changePage(event.key === 'ArrowRight' ? 'next' : 'previous');
        }, options);
        const stage = this.querySelector('.mw-showcase__stage');
        stage.addEventListener('touchstart', event => {
          this.touchStart = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
        }, {...options, passive: true});
        stage.addEventListener('touchcancel', () => this.touchStart = null, options);
        stage.addEventListener('touchend', event => {
          if (!this.touchStart || !this.mobile.matches || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) {
            if (event.cancelable) event.preventDefault();
            this.changePage(dx < 0 ? 'next' : 'previous');
          }
        }, {...options, passive: false});
        if (this.dataset.opening === 'true' && !this.reducedMotion.matches && !window.Shopify?.designMode) {
          this.classList.add('is-closed');
          this.openingObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.openingObserver.disconnect();
              this.opening = this.moveCurtains(false);
            }
          }, {threshold: 0.12});
          this.openingObserver.observe(this.querySelector('.mw-showcase__frame'));
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.request?.abort();
        this.openingObserver?.disconnect();
        this.querySelectorAll('.mw-showcase__curtain').forEach(el => el.getAnimations().forEach(animation => animation.cancel()));
        this.initialized = false;
      }
      syncPage() {
        const page = this.querySelector('.mw-showcase__page');
        if (!page) return;
        const cards = [...page.querySelectorAll('.mw-card')];
        const size = this.mobile.matches ? 2 : 6;
        if (size === 6 || this.half * 2 >= cards.length) this.half = 0;
        cards.forEach((card, index) => card.hidden = size === 2 && Math.floor(index / 2) !== this.half);
        const offset = (Number(page.dataset.page) - 1) * 6 + this.half * 2;
        const total = Number(page.dataset.total);
        page.querySelector('.mw-showcase__counter').textContent = `${Math.floor(offset / size) + 1} / ${Math.ceil(total / size)}`;
        for (const direction of ['previous', 'next']) {
          const link = page.querySelector(`[data-direction="${direction}"]`);
          const enabled = direction === 'previous' ? offset > 0 : offset + size < total;
          link.setAttribute('aria-disabled', String(!enabled));
          link.tabIndex = enabled ? 0 : -1;
        }
      }
      async moveCurtains(closed) {
        const curtains = [...this.querySelectorAll('.mw-showcase__curtain')];
        if (this.reducedMotion.matches) { this.classList.toggle('is-closed', closed); return; }
        this.classList.add('is-moving');
        const animations = curtains.map((curtain, index) => {
          const sign = index === 0 ? -1 : 1;
          const positions = closed ? [103, 82, 22, 0] : [0, 12, 70, 103];
          return curtain.animate(positions.map((position, step) => ({
            transform: `translateX(${sign * position}%) scaleX(${step === 1 || step === 2 ? .98 : 1})`,
            offset: [0, .22, .72, 1][step]
          })), {duration: closed ? 1000 : 2300, easing: 'cubic-bezier(.45,0,.2,1)', fill: 'forwards'});
        });
        try { await Promise.all(animations.map(animation => animation.finished)); }
        catch (error) { if (this.isConnected) throw error; }
        finally {
          this.classList.toggle('is-closed', closed);
          animations.forEach(animation => animation.cancel());
          this.classList.remove('is-moving');
        }
      }
      async changePage(direction) {
        const current = this.querySelector('.mw-showcase__page');
        const link = current?.querySelector(`[data-direction="${direction}"]`);
        if (this.busy || !link || link.getAttribute('aria-disabled') === 'true') return;
        this.busy = true;
        this.classList.add('is-busy');
        this.setAttribute('aria-busy', 'true');
        const message = this.querySelector('.mw-showcase__message');
        message.textContent = '';
        message.classList.add('visually-hidden');
        const stage = this.querySelector('.mw-showcase__stage');
        const focusWasInNavigation = current.querySelector('.mw-showcase__controls').contains(document.activeElement);
        this.request = new AbortController();
        const timer = setTimeout(() => this.request.abort(), 12000);
        try {
          let page = current;
          let nextHalf = 0;
          const withinPage = this.mobile.matches && (direction === 'next' ? (this.half + 1) * 2 < current.querySelectorAll('.mw-card').length : this.half > 0);
          if (withinPage) {
            nextHalf = this.half + (direction === 'next' ? 1 : -1);
          } else {
            const path = current.dataset[direction];
            if (!path) return;
            const url = new URL(path, window.location.origin);
            url.hash = '';
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url, {signal: this.request.signal, credentials: 'same-origin'});
            if (!response.ok) throw new Error('section response');
            const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            page = fragment.querySelector('muheyya-weekly .mw-showcase__page');
            if (!page?.querySelector('.mw-card')) throw new Error('missing product page');
            nextHalf = this.mobile.matches && direction === 'previous' ? Math.floor((page.querySelectorAll('.mw-card').length - 1) / 2) : 0;
          }
          const cards = [...page.querySelectorAll('.mw-card')];
          const images = cards.filter((card, index) => !this.mobile.matches || Math.floor(index / 2) === nextHalf).flatMap(card => [...card.querySelectorAll('img')]);
          images.forEach(img => img.loading = 'eager');
          await Promise.race([Promise.all(images.map(img => img.decode().catch(() => {}))), new Promise(resolve => setTimeout(resolve, 1200))]);
          if (!this.isConnected) return;
          await this.opening;
          stage.style.minHeight = `${stage.offsetHeight}px`;
          await this.moveCurtains(true);
          if (!this.isConnected) return;
          if (page !== current) this.querySelector('.mw-showcase__content').replaceChildren(page);
          this.half = nextHalf;
          this.syncPage();
          await this.moveCurtains(false);
          message.textContent = page.querySelector('.mw-showcase__counter').textContent;
          if (focusWasInNavigation) {
            const nextFocus = page.querySelector(`a[data-direction="${direction}"][aria-disabled="false"]`) || page.querySelector('a[aria-disabled="false"]');
            nextFocus?.focus({preventScroll: true});
          }
        } catch (error) {
          if (this.isConnected) { message.classList.remove('visually-hidden'); message.textContent = this.dataset.error; }
        } finally {
          clearTimeout(timer);
          this.classList.remove('is-closed', 'is-busy');
          stage.style.minHeight = '';
          this.removeAttribute('aria-busy');
          this.busy = false;
          this.syncPage();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
